import Vue from 'vue'
import Vuex from 'vuex'

import DietImpact from '@/store/DietImpact'
import Meals from '@/store/Meals'
import Region from '@/store/Region'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuShown: false
  },
  modules: {
    DietImpact,
    Meals,
    Region
  },
  mutations: {
    TOGGLE_MENU_SHOWN(state) {
      state.menuShown = !state.menuShown
    }
  },
  actions: {

  }
})
